import { FC } from 'react';

type Props = {
	className?: string;
};

const MoneyReceiveCircleIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.5998 2.17743C11.0829 2.07261 10.5478 2.01758 9.99984 2.01758C5.58165 2.01758 2 5.5953 2 10.0086C2 14.4219 5.58165 17.9997 9.99984 17.9997C14.418 17.9997 17.9997 14.4219 17.9997 10.0086C17.9997 9.46138 17.9446 8.92683 17.8397 8.41044'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M9.99841 7.6116C9.11474 7.6116 8.39844 8.14827 8.39844 8.81024C8.39844 9.47222 9.11474 10.0089 9.99841 10.0089C10.8821 10.0089 11.5984 10.5456 11.5984 11.2075C11.5984 11.8695 10.8821 12.4062 9.99841 12.4062M9.99841 7.6116C10.695 7.6116 11.2877 7.94516 11.5073 8.41072M9.99841 7.6116V6.8125M9.99841 12.4062C9.30178 12.4062 8.70915 12.0727 8.48948 11.6071M9.99841 12.4062V13.2053'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M17.996 2L14.6554 5.33883M13.9961 2.41694L14.0907 4.88737C14.0907 5.46964 14.4387 5.83242 15.0727 5.87818L17.5719 5.99553'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default MoneyReceiveCircleIcon;
